import { Injectable } from '@angular/core';
import { BaseHttpService } from 'src/app/services/base-http-service.service';
import { AuthInterceptorService } from 'src/app/interceptors/auth.interceptor';

@Injectable({
  providedIn: 'root'
})
export class StripeCustomerService extends BaseHttpService {
  constructor(authInterceptor: AuthInterceptorService) {
    super(authInterceptor);
  }

  // ! POST Requests

  // ! GET Requests
  
  // ! PUT Requests
}